import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { finalizeEntry } = stateEnum

const initialState = {
  detailParams: {},
  isNewEntry: false,
  
}


const FinalizeMemoEntrySlice = createSlice({
  name: finalizeEntry,
  initialState,
  reducers: {

    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload

    },
   
   
  },

})

export const { setDetailParams, resetDetailParams, setNewEntryMode,  } =  FinalizeMemoEntrySlice.actions
export default FinalizeMemoEntrySlice.reducer
